import { serializeObject } from "../common/helper";
import { Request } from "./HttpService";

export const technologyService = {
  getTechnologies(pageSize, pageNumber, searchObject) {
    let url = `vitae/technology/${pageSize}/${pageNumber}?${serializeObject(
      searchObject
    )}`;
    return Request(url, "GET");
  },
  getTechnologyById(technologyId) {
    return Request(`vitae/technology/${technologyId}`, "GET");
  },
  createOrUpdate(technology) {
    return Request(`vitae/technology`, "POST", technology);
  },
  deleteTechnology(technologyId) {
    return Request(`vitae/technology/${technologyId}`, "DELETE");
  },
  searchTecnologies(technology) {
    return Request(`vitae/technology/search/${technology}`, "GET");
  }
};
